import { useNavigate, useRouteError } from "react-router-dom";
import { StyledErrorPage } from "./error-page.styled";
import { useEffect, useMemo, useState } from "react";
import { useAuth } from "@features/auth/contexts/AuthContext";
import { toast } from "react-toastify";
import { logError, normalizeError } from "@shared/lib/errors";
import { PageErrorState } from "@shared/ui/errors";

function ErrorPage() {
  const { logoutUser } = useAuth();
  const navigate = useNavigate();

  const error: unknown = useRouteError();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const appError = useMemo(() => normalizeError(error), [error]);

  useEffect(() => {
    logError(appError, "route-error-page");

    if (appError.shouldLogout || appError.kind === "auth") {
      async function handleLogOut() {
        await logoutUser();
        navigate("/login");
        toast.error(
          <>
            נותקת עקב חוסר פעילות. <br />
            יש להתחבר מחדש.
          </>,
          { autoClose: 5000, toastId: "session-expired" }
        );
      }

      handleLogOut();
      return;
    }

    setIsLoading(false);
  }, [appError, logoutUser, navigate]);

  return (
    <StyledErrorPage>
      {!isLoading ? (
        <PageErrorState message={appError.userMessage} status={appError.status} onBackHome={() => navigate("/")} />
      ) : null}
    </StyledErrorPage>
  );
}

export default ErrorPage